// Hằng số dùng chung.
//
// ⚠️ QUY TẮC: KHÔNG hardcode số liệu kinh doanh trong file này.
// Mọi số thực tế đến từ src/data/actuals.json — nguồn duy nhất, đã đối chiếu
// khớp $0 với P&L của kế toán (Monthly P&L + Financial Statement May26).
// Chi tiết nguồn xem khối `_meta` trong actuals.json.

import ACTUALS from './data/actuals.json';

// ── Lịch / helper ngày ───────────────────────────────────────────────
export const MONTHS = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
export const DAYS_IN_MO = [31,28,31,30,31,30,31,31,30,31,30,31];

const _d = new Date();
export const TODAY_DAY = _d.getDate();
export const CURRENT_MONTH = _d.getMonth();      // 0..11
export const MTD_RATIO = TODAY_DAY / DAYS_IN_MO[CURRENT_MONTH];

// ── Dữ liệu thực tế (nguồn duy nhất) ─────────────────────────────────
export const DATA = ACTUALS;
export const BUS = ['CAR', 'HELI', 'JET'];

/** Chỉ số tháng cuối cùng đã có số thực tế (0-based). */
export const ACTUAL_THROUGH = ACTUALS.fy2026.actual_through;

/** Dựng mảng 12 phần tử; tháng chưa có số điền null. */
const pad12 = (arr) => Array.from({ length: 12 }, (_, i) => (arr[i] ?? null));

// ── Dự báo GMV ───────────────────────────────────────────────────────
// Đây là KẾ HOẠCH nên vẫn là hằng số. Không lẫn với số thực tế.
export const GMV_FC = {
  CAR:  [504171, 471923, 421177, 399851, 467768, 480242, 561321, 467768, 467768, 498952, 561321, 629303],
  HELI: [994403, 930799, 830710, 788648, 871148, 868825, 944325, 1004724, 764287, 1000078, 1297430, 950132],
  JET:  [128949, 120701, 107722, 102268, 143894, 117021, 181631, 137033, 142941, 177247, 193638, 170005],
};

// ── GMV thực tế ──────────────────────────────────────────────────────
// Lấy thẳng từ sổ kế toán. Bản hardcode cũ sai tới +44,7% (HELI tháng 1).
export const GMV_ACT = {
  CAR:  pad12(ACTUALS.fy2026.gmv_actual.CAR),
  HELI: pad12(ACTUALS.fy2026.gmv_actual.HELI),
  JET:  pad12(ACTUALS.fy2026.gmv_actual.JET),
};

// ── Tỷ lệ P&L ────────────────────────────────────────────────────────
// Đo từ 5 tháng thực tế 2026, không phải số giả định.
// Chỉ áp cho tháng DỰ BÁO; tháng đã có actual thì đọc thẳng số thực.
export const RATES = ACTUALS.fy2026.rates_actual;

// ── Cấu hình khác ────────────────────────────────────────────────────
export const SHEET_ID = '1ffeWfYwb3mFzBlASFvJD_nAlkjDiX27qWN7jMkrwrfM';
export const AUTO_REFRESH_MS = 6 * 60 * 60 * 1000;
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

// Các tháng nửa cuối năm cho modal sửa dự báo
export const H2_MONTHS = [5, 6, 7, 8, 9, 10, 11];
